export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14341.61db26cb.jpg";